import { useEffect, useRef, useState } from 'react';
import { MdClose, MdOutlineError, MdRecordVoiceOver } from 'react-icons/md';
import { RiWhatsappFill } from 'react-icons/ri';
import { useAuth } from 'hooks';
import { Modal, ReportFail, Text } from 'components';
import { FontSize, TEST_IDS } from 'commons';
import * as S from './styles';

interface Props {
  consignmentCode: string;
  showDeliveryFail?: boolean;
  isReturn?: boolean;
}

export function FabSupport({
  consignmentCode,
  showDeliveryFail = false,
  isReturn = false,
}: Props) {
  const { selectedStore, user } = useAuth();
  const { isAdmin } = user;
  const [isOpen, setIsOpen] = useState(false);
  const toggleButtonRef = useRef<HTMLButtonElement>(null);
  const toggleModalRef = useRef<HTMLLabelElement>(null);
  const store = selectedStore.name || '';
  const supportText = isReturn
    ? `Retire%20e%20Entrega%20-%20Loja%20*${store}*%20Sobre%20a%20devolução%20do%20pedido%20*${consignmentCode}*`
    : `Retire%20e%20Entrega%20-%20Loja%20*${store}*%20Sobre%20o%20pedido%20*${consignmentCode}*`;
  const supportLink = `https://api.whatsapp.com/send?phone=+555121295354&text=${supportText}`;

  function toggleIsOpen(event: React.MouseEvent<HTMLElement>) {
    event.stopPropagation();

    setIsOpen(!isOpen);
  }

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const { current } = toggleButtonRef;

      if (current && !current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }

    if (isOpen) {
      document.addEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isOpen]);

  function toggleModal() {
    setIsOpen(false);

    const { current } = toggleModalRef;

    if (current) {
      current.click();
    }
  }

  if (isAdmin) {
    return <></>;
  }

  return (
    <S.Main data-testid={TEST_IDS.FAB_SUPPORT_WRAPPER}>
      {showDeliveryFail && (
        <Modal modalContent={<ReportFail consignmentCode={consignmentCode} />}>
          <label hidden ref={toggleModalRef} />
        </Modal>
      )}

      {isOpen && (
        <S.Content>
          {showDeliveryFail && (
            <S.Option onClick={toggleModal}>
              <div className="icon">
                <MdOutlineError />
              </div>

              <Text size={FontSize.font12}>Falha na entrega</Text>
            </S.Option>
          )}

          <S.Anchor target="_blank" rel="noreferrer" href={supportLink}>
            <S.Option>
              <div className="icon">
                <RiWhatsappFill />
              </div>

              <Text size={FontSize.font12}>Suporte EASY</Text>
            </S.Option>
          </S.Anchor>
        </S.Content>
      )}

      <S.ToggleButton
        data-testid={TEST_IDS.FAB_SUPPORT_TOGGLE}
        ref={toggleButtonRef}
        onClick={toggleIsOpen}
      >
        <div className="icon">
          {isOpen ? <MdClose size={32} /> : <MdRecordVoiceOver size={24} />}
        </div>
      </S.ToggleButton>
    </S.Main>
  );
}
